import { Flex, Box, Text, FormLabel, Input } from "@chakra-ui/react";

import { doubleArrowRight } from "../../../assets";

import { Block } from "./MainBlocks/Block";
import CustomScroll from "react-custom-scroll";

export const Head05 = ({
  id,
  side,
  sentence,
  fam,
  size,
  height,
  spacing,
  weight,
  settings,
}) => {
  return (
    <Block id={id} sidebar={side}>
      <Box mb="8px">
        <CustomScroll>
          <Text
            width={{ base: "2000px", md: "100%", lg: "100%" }}
            maxHeight="500px"
            minH="100%"
            style={{ transition: "all .3s ease" }}
            fontFamily={fam}
            fontSize={size}
            lineHeight={`${height}px`}
            letterSpacing={`${spacing}px`}
            fontWeight={weight}
            mb="8px"
          >
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolore
            veritatis voluptatum reiciendis mollitia ad a officiis earum
            molestias sunt, libero deleniti ducimus dolor dolores repellendus
            autem facere architecto quaerat vitae exercitationem nisi dicta.
            {sentence}
          </Text>
        </CustomScroll>
      </Box>

      <hr style={{ width: "85%" }} />

      {/* FORM LABEL */}
      <Box mb="15px" mt="15px">
        <CustomScroll>
          <Flex
            mb="15px"
            mt="15px"
            width={{ base: "200%", md: "100%", lg: "100%" }}
            maxHeight="500px"
            minH="100%"
          >
            <Box mr={["36px"]}>
              <FormLabel
                fontFamily={fam}
                fontSize={size}
                lineHeight={`${height}px`}
                letterSpacing={`${spacing}px`}
                fontWeight={weight}
                mb={["4px"]}
              >
                Name
              </FormLabel>
              <Input
                type="text"
                width="100%"
                borderColor="#131215"
                borderRadius="0px"
              />
            </Box>

            <Box mr={["36px"]}>
              <FormLabel
                fontFamily={fam}
                fontSize={size}
                lineHeight={`${height}px`}
                letterSpacing={`${spacing}px`}
                fontWeight={weight}
                mb={["4px"]}
              >
                Email
              </FormLabel>
              <Input
                type="email"
                width="100%"
                borderColor="#131215"
                borderRadius="0px"
              />
            </Box>

            <Box mr={["36px"]}>
              <FormLabel
                fontFamily={fam}
                fontSize={size}
                lineHeight={`${height}px`}
                letterSpacing={`${spacing}px`}
                fontWeight={weight}
                mb={["4px"]}
              >
                Password
              </FormLabel>
              <Input
                type="password"
                width="100%"
                borderColor="#131215"
                borderRadius="0px"
              />
            </Box>
          </Flex>
        </CustomScroll>
      </Box>
      <hr style={{ width: "85%" }} />

      {/* PAGINATION */}
      <Box mb="15px" mt="15px">
        <CustomScroll>
          <Flex
            mb="15px"
            mt="15px"
            width={{ base: "200%", md: "100%", lg: "100%" }}
            maxHeight="500px"
            minH="100%"
            alignItems="center"
            // Font variables
            fontFamily={fam}
            fontSize={size}
            lineHeight={`${height}px`}
            letterSpacing={`${spacing}px`}
            fontWeight={weight}
          >
            <Box mr={["20px"]}>1</Box>
            <Box
              mr={["20px"]}
              px={["15px"]}
              py={["10px"]}
              bg={"#131215"}
              color="#f8f8f8"
            >
              2
            </Box>
            <Box mr={["12px"]}>3</Box>
            <img src={doubleArrowRight} alt="next" />
          </Flex>
        </CustomScroll>
      </Box>
      <hr style={{ width: "85%" }} />

      {/* Settings Block */}
      {settings}
    </Block>
  );
};
